module.exports = __webpack_public_path__ + "static/giveaway-af6906efa721584fb1ee62e8abf1558d.png";